export default "__VITE_ASSET__DFGs8PB4__"